import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2024SistemasDeMedicion() {
  return <CategoryPage category="anexo30Y31Ano2024SistemasDeMedicion" pageTitle="Sistemas De Medicion 2024" />;
}

export default Anexo30Y31Ano2024SistemasDeMedicion;
